import { render, staticRenderFns } from "./pre_input.vue?vue&type=template&id=572524bb"
import script from "./pre_input.vue?vue&type=script&lang=js"
export * from "./pre_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports